import { styled } from '@mui/system';

export const SearchContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSearchbarWhite',
})<{ isSearchbarWhite?: boolean }>(({ theme, isSearchbarWhite }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  height: '40px',
  borderRadius: '36px',
  padding: '0 16px',
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.grey[800]
      : theme.palette.grey[100],
  position: 'relative',
  ...(isSearchbarWhite && {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.divider}`,
  }),

  // Mobile: take full remaining width (fluid) with smaller gap
  [theme.breakpoints.down('sm')]: {
    flex: 1,
    width: 'auto',
    gap: '4px',
  },

  // Tablet: fixed width
  [theme.breakpoints.between('sm', 'md')]: {
    flex: 1,
    width: 'auto',
  },

  // Desktop: fixed width
  [theme.breakpoints.up('md')]: {
    width: '100%',
    flex: '0 0 auto',
  },
}));

export const InputWrapper = styled('div')(() => ({
  position: 'relative',
  flex: 1,
  height: '100%',
  width: '100%',
  minWidth: 0, // Allow flex item to shrink
  display: 'flex',
  alignItems: 'center',
  zIndex: 1,
  cursor: 'text', // Show text cursor when hovering over the wrapper
}));

export const IconsContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const OverlayDiv = styled('div')(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: 10,
}));

export const StyledInput = styled('input')(() => ({
  position: 'relative',
  zIndex: 2,
  width: '100%',
  minWidth: 0,
  height: '100%',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  font: 'inherit',
  color: 'inherit',
  padding: 0,
  margin: 0,
  '&::placeholder': {
    opacity: 1,
  },
  '&:disabled': {
    cursor: 'not-allowed',
  },
}));
